import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useNotificationSettingsStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(2),

      [theme.breakpoints.up('md')]: {
        paddingTop: theme.spacing(6)
      }
    },

    tabContainer: {
      marginBottom: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        justifyContent: 'space-between'
      }
    },

    title: {
      marginTop: theme.spacing(3),

      [theme.breakpoints.up('md')]: {
        marginTop: 0
      }
    },

    tab: {
      maxWidth: 'max-content',
      minWidth: 'min-content'
    },

    tabPanel: {
      padding: 0
    },

    button: {
      marginLeft: 'auto'
    },

    select: {
      marginTop: theme.spacing(3),

      [theme.breakpoints.up('md')]: {
        marginTop: 0
      }
    },

    selectOptionSetting: {
      select: {
        width: '100%',

        [theme.breakpoints.up('md')]: {
          width: 'auto'
        }
      }
    }
  })
)
